<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
            <d-col col sm="6" class="text-left text-sm-left mb-4 mb-sm-0">
        <h3 class="page-title">
          <template v-if="isEdit">Edytuj opakowanie</template>
          <template v-else>Nowe opakowanie</template>
        </h3>
      </d-col>
      <d-col
        col
        sm="6"
        class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button
          theme="primary"
          outline
          @click.prevent="$router.push('/packages/')"
          class="mr-1">
          <i class="material-icons">arrow_back</i>
          Wróć do listy
        </d-button>
        <d-button
          v-if="isEdit"
          theme="warning"
          @click.prevent="showDuplicateModal"
          class="mr-1">
          <i class="material-icons">content_copy</i>
          Duplikuj
        </d-button>
        <d-button
          theme="success"
          @click.prevent="validateForm">
          <i class="material-icons">done</i>
          Zapisz zmiany
        </d-button>
      </d-col>
    </d-row>

    <!-- Form -->
    <d-form>
      <d-row>
        <d-col cols="6">
          <d-card class="mb-5">
            <d-card-body>
              <validation-observer
                v-if="allDataLoaded"
                ref="package-form"
                tag="form">
                <div class="form-group">
                  <label for="name">
                    Nazwa:
                  </label>

                  <validation-provider
                    rules="required"
                    name="name"
                    v-slot="{ errors }">
                    <d-input
                      :state="errors.length ? 'invalid' : null"
                      v-model="data.name" />
                    <div class="invalid-feedback">
                      {{ errors[0] }}
                    </div>
                  </validation-provider>
                </div>

                <div class="form-group">
                  <toggle-switch v-model="data.is_drink">
                    Opakowanie dla napoju
                  </toggle-switch>
                </div>
              </validation-observer>

              <div v-if="!allDataLoaded" class="pb-3 pt-3 text-center">
                Trwa ładowanie danych&hellip;
              </div>

              <d-alert
                v-if="loadError"
                show
                theme="warning">
                Wczytywanie danych nie powiodło się. <a href="javascript:window.location.reload();" class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
              </d-alert>
            </d-card-body>
          </d-card>
        </d-col>

        <d-col cols="6">
          <div class="form-group">
            <label for="image" class="text-center w-100">
              Ilustracja
              <small>Dodawana ilustracja musi być plikiem SVG z przezroczystością</small>
            </label>

            <div
              v-if="data.image_url"
              class="image-wrapper">
              <img :src="data.image_url" />
            </div>

            <div
              v-if="data.image_url"
              class="text-center mt-5">
              <d-button
                theme="danger"
                outline
                @click.prevent="removeImage()">
                Zmień ilustrację
              </d-button>
            </div>

            <file-input
              v-if="!data.image_url"
              :onChange="setImage"
              id="image" />
          </div>
        </d-col>
      </d-row>
    </d-form>
  </d-container>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';
import ToggleSwitch from './../common/ToggleSwitch.vue';

export default {
  name: 'package-form',
  components: {
    'toggle-switch': ToggleSwitch
  },
  computed: {
    allDataLoaded () {
      return this.loaded;
    },
    isEdit () {
      return !!this.$route.params.id;
    }
  },
  data() {
    return {
      data: {
        id: 0,
        name: '',
        image: null,
        image_url: '',
        is_drink: false
      },
      loaded: false,
      loadError: false
    };
  },
  mounted () {
    if (this.isEdit) {
      this.loadItemData();
    } else {
      this.loaded = true;
    }
  },
  methods: {
    loadItemData () {
      FormUtils.loadItemData(this, {
        endpointBase: '/packages/item/',
        instanceFields: ['id', 'name', 'image_url', 'is_drink'],
        booleanFields: ['is_drink'],
        loadedKey: 'loaded'
      });
    },
    validateForm () {
      FormUtils.validate(this.$refs['package-form'], this.submitForm);
    },
    submitForm () {
      let endpointUrl = this.isEdit ? '/packages/update/' + this.id : '/packages/store';

      if (this.data.image !== null) {
        FormUtils.submit(this, {
          endpoint: endpointUrl,
          formData: {
            name: this.data.name,
            image: this.data.image,
            is_drink: this.data.is_drink
          },
          successTitle: 'Zapisano opakowanie',
          successText: 'Wybrane opakowanie zostało zapisane',
          errorTitle: 'Wystąpił błąd',
          errorText: 'Zapis nie powiódł się. Spróbuj ponownie.',
          successAction: () => {
            this.$router.push('/packages')
          }
        }, ['image']);
      } else {
        FormUtils.submit(this, {
          endpoint: endpointUrl,
          formData: {
            name: this.data.name,
            is_drink: this.data.is_drink
          },
          successTitle: 'Zapisano opakowanie',
          successText: 'Wybrane opakowanie zostało zapisane',
          errorTitle: 'Wystąpił błąd',
          errorText: 'Zapis nie powiódł się. Spróbuj ponownie.',
          successAction: () => {
            this.$router.push('/packages')
          }
        });
      }
    },
    setImage (event) {
      this.data.image = event.target.files[0];
    },
    removeImage () {
      this.data.image_url = '';
      this.data.image = null;
    },
    showDuplicateModal () {
      this.$swal({
        title: 'Potwierdzenie duplikacji',
        html: 'Czy na pewno chcesz zduplikować OPAKOWANIE - <b>' + (this.data.name || '') + '</b>?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Duplikuj',
        cancelButtonText: 'Anuluj',
        buttonsStyling: true
      }).then((result) => {
        if (result.isConfirmed) {
          this.duplicatePackage();
        }
      });
    },
    duplicatePackage () {
      this.$http
        .post('/packages/duplicate/' + this.data.id)
        .then((response) => {
          if (response.data.success) {
            const newPackageId = response.data.new_id || 
                                response.data.id || 
                                response.data.package_id || 
                                (response.data.item && response.data.item.id) ||
                                (response.data.package && response.data.package.id);
            
            if (newPackageId) {
              this.$swal({
                title: 'Sukces',
                text: response.data.message || 'Opakowanie został zduplikowane',
                icon: 'success',
              }).then(() => {
                this.$router.push('/packages/' + newPackageId);
              });
            } else {
              this.$swal({
                title: 'Sukces',
                text: response.data.message || 'Opakowanie został zduplikowane',
                icon: 'success',
              });
            }
          } else {
            this.$swal({
              title: 'Błąd',
              text: response.data.message || 'Nie udało się zduplikować opakowania',
              icon: 'error',
            });
          }
        })
        .catch((error) => {
          this.$swal({
            title: 'Błąd',
            text: 'Wystąpił problem podczas duplikowania opakowania',
            icon: 'error',
          });
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.image-wrapper {
  img {
    display: block;
    margin: 30px auto;
    max-width: 80%;
  }
}
</style>
